import { motion } from 'framer-motion'
import { Card, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { CheckCircle, XCircle, Copy } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

interface RequestResultProps {
  result: {
    success: boolean
    message: string
    requestId?: string
  }
}

// Removed fade-up variants

export function RequestResult({ result }: RequestResultProps) {
  const copyRequestId = () => {
    if (result.requestId) {
      navigator.clipboard.writeText(result.requestId)
    }
  }

  return (
    <TooltipProvider>
      <div>
        <Card className={`border ${
          result.success 
            ? 'border-green-200/50 dark:border-green-800/50 bg-green-50/30 dark:bg-green-950/20' 
            : 'border-red-200/50 dark:border-red-800/50 bg-red-50/30 dark:bg-red-950/20'
        }`}>
          <CardContent className="pt-6">
            <div className="flex items-start gap-3">
              <div className={`p-2 rounded-lg flex-shrink-0 ${
                result.success 
                  ? 'bg-green-100 dark:bg-green-900/50' 
                  : 'bg-red-100 dark:bg-red-900/50'
              }`}>
                {result.success ? (
                  <CheckCircle className="h-4 w-4 text-green-600 dark:text-green-400" />
                ) : (
                  <XCircle className="h-4 w-4 text-red-600 dark:text-red-400" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="font-semibold text-foreground">
                    {result.success ? 'Request Created Successfully' : 'Request Failed'}
                  </h3>
                  <Badge 
                    variant={result.success ? "default" : "destructive"}
                    className="text-xs"
                  >
                    {result.success ? 'Success' : 'Error'}
                  </Badge>
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {result.message}
                </p>
                {result.requestId && (
                  <div className="flex items-center gap-2 mt-3 p-2 rounded-lg bg-muted/50">
                    <span className="text-xs text-muted-foreground">Request ID:</span>
                    <code className="text-xs bg-background px-2 py-1 rounded border font-mono flex-1">
                      {result.requestId}
                    </code>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={copyRequestId}
                          className="h-6 w-6 p-0"
                        >
                          <Copy className="h-3 w-3" />
                        </Button>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p>Copy request ID</p>
                      </TooltipContent>
                    </Tooltip>
                  </div>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </TooltipProvider>
  )
} 